// AUTO-GENERATED SQL Builder (V40 Final) for EventSession
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class EventSessionSql {
  private ast = new SqlAst('EventSession', 'eventSession');
  public readonly main: any = {};

  public guid: SqlField;
  public code: SqlField;
  public label: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public blockedDateList: SqlNavHybrid;
  public bookingList: SqlNavHybrid;
  public bookingChangeProposalList: SqlNavHybrid;
  public bookingPackageList: SqlNavHybrid;
  public offeringSessionList: SqlNavHybrid;
  public packageItemList: SqlNavHybrid;
  public resaleList: SqlNavHybrid;
  public resaleTermList: SqlNavHybrid;
  public waitlistList: SqlNavHybrid;
  public weddingCardList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('eventSession', 'guid', '', 'id', 'eventSession_guid');
    this.code = new SqlField('eventSession', 'code', '', 'id', 'eventSession_code');
    this.label = new SqlField('eventSession', 'label', '', 'id', 'eventSession_label');
    this.createdByUser = createNavHybrid('eventSession', 'eventSession_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('eventSession', 'eventSession_updatedByUser', 'User');
    this.blockedDateList = createNavHybrid('eventSession', 'eventSession_blockedDateList', 'BlockedDate');
    this.bookingList = createNavHybrid('eventSession', 'eventSession_bookingList', 'Booking');
    this.bookingChangeProposalList = createNavHybrid('eventSession', 'eventSession_bookingChangeProposalList', 'BookingChangeProposal');
    this.bookingPackageList = createNavHybrid('eventSession', 'eventSession_bookingPackageList', 'BookingPackage');
    this.offeringSessionList = createNavHybrid('eventSession', 'eventSession_offeringSessionList', 'OfferingSession');
    this.packageItemList = createNavHybrid('eventSession', 'eventSession_packageItemList', 'PackageItem');
    this.resaleList = createNavHybrid('eventSession', 'eventSession_resaleList', 'Resale');
    this.resaleTermList = createNavHybrid('eventSession', 'eventSession_resaleTermList', 'ResaleTerm');
    this.waitlistList = createNavHybrid('eventSession', 'eventSession_waitlistList', 'Waitlist');
    this.weddingCardList = createNavHybrid('eventSession', 'eventSession_weddingCardList', 'WeddingCard');
    this.id = new SqlField('eventSession', 'id', '', 'id', 'eventSession_id');
    this.isDeleted = new SqlField('eventSession', 'isDeleted', '', 'id', 'eventSession_isDeleted');
    this.createdBy = new SqlField('eventSession', 'createdBy', '', 'id', 'eventSession_createdBy');
    this.createdDate = new SqlField('eventSession', 'createdDate', '', 'id', 'eventSession_createdDate');
    this.updatedBy = new SqlField('eventSession', 'updatedBy', '', 'id', 'eventSession_updatedBy');
    this.updatedDate = new SqlField('eventSession', 'updatedDate', '', 'id', 'eventSession_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:EventSessionSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:EventSessionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:EventSessionSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:EventSessionSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:EventSessionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:EventSessionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:EventSessionSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:EventSessionSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:EventSessionSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:EventSessionSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
